// extracted by mini-css-extract-plugin
export default {"downloadBox":"pc_downloadBox__Z17l8","downloadTitle":"pc_downloadTitle__RXISk","codeImg":"pc_codeImg__yGKpl","downloadInfo":"pc_downloadInfo__J5Rg8"};